import { render } from "./UomDropdown.vue?vue&type=template&id=13ed4c21&scoped=true"
import script from "./UomDropdown.vue?vue&type=script&lang=js"
export * from "./UomDropdown.vue?vue&type=script&lang=js"

import "./UomDropdown.vue?vue&type=style&index=0&id=13ed4c21&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed4c21"]])

export default __exports__